import createReactComponent from '../createReactComponent';
var Cpu = createReactComponent('Cpu', [['rect', {
  x: '4',
  y: '4',
  width: '16',
  height: '16',
  rx: '2',
  ry: '2',
  key: '19czt8'
}], ['rect', {
  x: '9',
  y: '9',
  width: '6',
  height: '6',
  key: 'o3kz5p'
}], ['line', {
  x1: '9',
  y1: '1',
  x2: '9',
  y2: '4',
  key: 'uurdzi'
}], ['line', {
  x1: '15',
  y1: '1',
  x2: '15',
  y2: '4',
  key: '1h36bx'
}], ['line', {
  x1: '9',
  y1: '20',
  x2: '9',
  y2: '23',
  key: 'w30l3c'
}], ['line', {
  x1: '15',
  y1: '20',
  x2: '15',
  y2: '23',
  key: 'rgidm0'
}], ['line', {
  x1: '20',
  y1: '9',
  x2: '23',
  y2: '9',
  key: '15c23i'
}], ['line', {
  x1: '20',
  y1: '14',
  x2: '23',
  y2: '14',
  key: '1gcit2'
}], ['line', {
  x1: '1',
  y1: '9',
  x2: '4',
  y2: '9',
  key: 'dcmdke'
}], ['line', {
  x1: '1',
  y1: '14',
  x2: '4',
  y2: '14',
  key: '1usk92'
}]]);
export default Cpu;